import React from 'react';
import styles from './Select.module.scss';
import ArrowDown from '@/shared/assets/icons/arrow_down.svg';

interface Option {
  value: string;
  label: string;
}

export interface SelectProps {
  value: string;
  options: Option[];
  onChange: (value: string) => void;
  disabled?: boolean;
  error?: string;
  placeholder?: string;
  className?: string;
}

export const Select: React.FC<SelectProps> = ({
  value,
  options,
  onChange,
  disabled,
  error,
  className,
  placeholder,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(e.target.value);
  };

  return (
    <div className={styles.wrapper}>
      <select
        value={value}
        onChange={handleChange}
        disabled={disabled}
        className={[styles.select, error ? styles.error : '', className || ''].filter(Boolean).join(' ')}
      >
        {placeholder && (
          <option value="" disabled hidden>
            {placeholder}
          </option>
        )}
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      <ArrowDown className={styles.icon} />
    </div>
  );
};
